import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
const ThemedDiv = styled.div`
  background: ${({ theme }) => theme.bg4};
  color: ${({ theme }) => theme.textColor};
`;

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  lazyLoad: 'on demand',
};

const FullStack = () => {
  return (
    <ThemedDiv>
      <div id='fullstack' className='container pt-5 pb-5'>
        <div className='container'>
          <h2 className='heading-lg'>full-stack projects</h2>
          <div className='carousel'>
            <Slider {...settings}>
              <div className='slide'>
                <img
                  src='Blockwatch/blockwatch.gif'
                  alt='blockwatch-gif'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    window
                      .open('https://blockwatch.netlify.app/', '_blank')
                      .focus();
                  }}
                />
                <div className='slide-caption'>
                  <h3>
                    Blockwatch - A modern way to connect and keep your community
                    safe{' '}
                  </h3>
                  <p>React, Express, NodeJS, MongoDB </p>
                </div>
              </div>
              <div className='slide'>
                <img
                  src='Konnect/konnect.gif'
                  alt='konnect-gif'
                  // style={{ cursor: 'pointer' }}
                  // onClick={() => {
                  //   window
                  //     .open('https://blockwatch.netlify.app/', '_blank')
                  //     .focus();
                  // }}
                />
                <div className='slide-caption'>
                  <h3>
                    Konnect Redis Cache - An internal facing app for visualizing
                    and managing Redis keys
                  </h3>
                  <p>React w TypeScript, .NET Core, Redis </p>
                </div>
              </div>
              <div className='slide'>
                <img
                  src='Soilmates/soilmates-1.gif'
                  alt='soilmates-gif'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    window
                      .open('https://soil-mates.herokuapp.com/', '_blank')
                      .focus();
                  }}
                />
                <div className='slide-caption'>
                  <h3>SoilMates - Connect with local Plant Stores</h3>
                  <p>EJS, Express, MongoDB </p>
                </div>
              </div>
              <div class='slide'>
                <img
                  src='Whisk/whisk-1.gif'
                  alt='whisk-gif'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    window
                      .open(
                        'https://romantic-noether-57a525.netlify.app/',
                        '_blank'
                      )
                      .focus();
                  }}
                />
                <div className='slide-caption'>
                  <h3>WHISK - An "experience-first" dating app</h3>
                  <p>React, AWS Cognito, Amplify, DynamoDB </p>
                </div>
              </div>
              {/* <div className='slide'>
                <img src='Amazon/amazon-1.gif' alt='amazon-gif' />
                <div className='slide-caption'>
                  <h3>An Amazon Clone</h3>
                  <p>
                    React, Firebase Auth, Firestore Purchase History, Stripe
                    Payment
                  </p>
                </div>
              </div> */}

              <div className='slide'>
                <img
                  src='PokeVerse/pokeverse.gif'
                  alt='amazon-gif'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    window
                      .open('https://pokeverse.azurewebsites.net/', '_blank')
                      .focus();
                  }}
                />
                />
                <div className='slide-caption'>
                  <h3>PokeVerse - Catch & Add them all!</h3>
                  <p>
                    Razor Pages, C#/ASP.NET, SQL, Auth, SendGrid, ReCaptchaAzure
                    Deployment
                  </p>
                </div>
              </div>
            </Slider>
          </div>
          <div className='d-flex justify-content-end mt-5'>
            <Link to='/projects' className='link-to'>
              <span
                style={{
                  color: '#69A1AC',
                  textShadow: '1px 1px #2F3676',
                  letterSpacing: '2px',
                }}
              >
                See all projects --->>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </ThemedDiv>
  );
};

export default FullStack;
